<template>
  <el-row :gutter="20">
    <el-col
      :span="12"
      :offset="6">
      <div class="content-area-txt-tab">
        Bring your production team and audience together in real-time.TVU Partyline is the industry’s only real-time, ultra-low latency, <span
          class="info"
          v-popover:popover ><img src="../../assets/qsn-mark.svg"> </span>
      </div>
      <el-popover
        ref="popover"
        placement="bottom"
        width="290"
        trigger="click"

      >
        <div class="popover-content">    GUIDELINE
          NOTE: MAKE COPY of this SHEET and then produce your Quote
          Dimensions are set as "To Not Exceed"  i.e. a Partyline with up to x Hours/ y Participants and z Outputs
          Minimum purchase = $25/mo (for Subscription) or $45 (for Packs)

          Subscription
          When choosing annual (prepay) you save 1 month. Hours carryover when under subscription as long as you remain under subscription. Customer can choose to incur Overage charges  when under subscription - which will be billed at the end of the month in addition to the monthly subscription

          PrePaid Packs
          Packs valid for 3 months
          Overage pack hours are Billed upon completion of a Partyline Session (if customer elected to incur overage versus closing the PL session after a warning of X minutes)
          A session is considered closed when All participants left, VFB Stopped.

          Minimum 10/mo</div>
      </el-popover>
    </el-col>
  </el-row>
</template>
<script>
export default {
  data () {
    return {
      popoverVisible: false
    }
  }
}
</script>
<style scoped>
.content-area-txt-tab{
     padding: 20px 20px;
    text-align: center;
    color: #808080;
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
}
.el-popover.el-popper{
    background: #FFFFFF!important;
    border: 2px solid #E1E8EE;
    box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.1)!important;
    border-radius: 11px!important;
}
 .el-popper.is-light .el-popper__arrow::before{
      background: #E1E8EE!important;
  }
.el-popper.is-light[data-popper-placement^=bottom] .el-popper__arrow::before{
      border-color: #fff!important;
}
 .el-popper.is-light .el-popper__arrow::before {
    background: #ffffff!important;
}
.el-popper[data-popper-placement^=bottom] > .el-popper__arrow {
    top: -8px!important;
}
.el-popper.is-light .el-popper__arrow::before{
      border: 10px solid!important ;
}
</style>
